module.exports = __webpack_public_path__ + "img/hiihto.ecd9cb64.jpeg";